/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OtherProfessionalBackground = {
    Bank: 'BANK',
    Industry: 'INDUSTRY',
    Startup: 'STARTUP'
} as const;
export type OtherProfessionalBackground = typeof OtherProfessionalBackground[keyof typeof OtherProfessionalBackground];


export function instanceOfOtherProfessionalBackground(value: any): boolean {
    for (const key in OtherProfessionalBackground) {
        if (Object.prototype.hasOwnProperty.call(OtherProfessionalBackground, key)) {
            // @ts-ignore
            if (OtherProfessionalBackground[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OtherProfessionalBackgroundFromJSON(json: any): OtherProfessionalBackground {
    return OtherProfessionalBackgroundFromJSONTyped(json, false);
}

export function OtherProfessionalBackgroundFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherProfessionalBackground {
    return json as OtherProfessionalBackground;
}

export function OtherProfessionalBackgroundToJSON(value?: OtherProfessionalBackground | null): any {
    return value as any;
}

